import { passageConstants } from "../constants/passageConstants"

const initialState = {
  creatingPassage: false,
  fetchingPassage: false,
  updatingName: false,
  updatingCode: false,
  updatingNode: false,
  updatingTags: false
}

export function passages(state = initialState, action) {
  switch (action.type) {
    case passageConstants.NEW_PASSAGE_REQUEST:
      return {
        ...state,
        creatingPassage: true
      }
    case passageConstants.NEW_PASSAGE_SUCCESS:
      return {
        ...state,
        creatingPassage: false,
        createdPassage: action.passage
      }
    case passageConstants.NEW_PASSAGE_FAILURE:
      return {
        ...state,
        creatingPassage: false,
        passageError: action.error
      }

    case passageConstants.GET_PASSAGE_REQUEST:
      return {
        ...state,
        fetchingPassage: true
      }
    case passageConstants.GET_PASSAGE_SUCCESS:
      return {
        ...state,
        fetchingPassage: false,
        passage: action.passage
      }
    case passageConstants.GET_PASSAGE_FAILURE:
      return {
        ...state,
        fetchingPassage: false,
        passageError: action.error
      }

    case passageConstants.UPDATE_PASSAGE_NAME_REQUEST:
      return {
        ...state,
        updatingName: true
      }
    case passageConstants.UPDATE_PASSAGE_NAME_SUCCESS:
      return {
        ...state,
        updatingName: false,
        passage: {
          ...state.passage,
          name: action.name
        }
      }
    case passageConstants.UPDATE_PASSAGE_NAME_FAILURE:
      return {
        ...state,
        updatingName: false,
        passageError: action.error
      }

    case passageConstants.UPDATE_PASSAGE_CODE_REQUEST:
      return {
        ...state,
        updatingCode: true
      }
    case passageConstants.UPDATE_PASSAGE_CODE_SUCCESS:
      return {
        ...state,
        updatingCode: false,
        passage: {
          ...state.passage,
          code: action.code
        }
      }
    case passageConstants.UPDATE_PASSAGE_CODE_FAILURE:
      return {
        ...state,
        updatingCode: false,
        passageError: action.error
      }

    case passageConstants.UPDATE_PASSAGE_TAG_REQUEST:
      return {
        ...state,
        updatingTags: true
      }
    case passageConstants.UPDATE_PASSAGE_TAG_SUCCESS:
      return {
        ...state,
        updatingTags: false,
        passage: {
          ...state.passage,
          tags: action.tags
        }
      }
    case passageConstants.UPDATE_PASSAGE_TAG_FAILURE:
      return {
        ...state,
        updatingTags: false,
        passageError: action.error
      }

    case passageConstants.UPDATE_PASSAGE_NODE_REQUEST:
      return {
        ...state,
        updatingNode: true
      }
    case passageConstants.UPDATE_PASSAGE_NODE_SUCCESS:
      return {
        ...state,
        updatingNode: false,
        passage: {
          ...state.passage,
          node: action.node
        }
      }
    case passageConstants.UPDATE_PASSAGE_NODE_FAILURE:
      return {
        ...state,
        updatingNode: false,
        passageError: action.error
      }

    case passageConstants.UPDATE_PASSAGE_CONTENT_REQUEST:
      return {
        ...state,
        updatingPassage: true
      }
    case passageConstants.UPDATE_PASSAGE_CONTENT_SUCCESS:
      return {
        ...state,
        updatingPassage: false,
        passage: {
          ...state.passage,
          text: action.passage,
          beforeText: action.beforeText
        }
      }
    case passageConstants.UPDATE_PASSAGE_CONTENT_FAILURE:
      return {
        ...state,
        updatingPassage: false,
        passageError: action.error
      }

    case passageConstants.DELETE_PASSAGE_REQUEST:
      return {
        ...state,
        deletingPassage: true
      }
    case passageConstants.DELETE_PASSAGE_SUCCESS:
      return {
        ...state,
        deletingPassage: false
      }
    case passageConstants.DELETE_PASSAGE_FAILURE:
      return {
        ...state,
        deletingPassage: false,
        passageError: action.error
      }

    case passageConstants.GET_ALL_PASSAGES_REQUEST:
      return {
        ...state,
        fetchingPassages: true
      }
    case passageConstants.GET_ALL_PASSAGES_SUCCESS:
      return {
        ...state,
        fetchingPassages: false,
        passages: action.passages
      }
    case passageConstants.GET_ALL_PASSAGES_FAILURE:
      return {
        ...state,
        fetchingPassages: false,
        passageError: action.error
      }

    default:
      return state
  }
}
